var __rspack_ns_object = JSON.parse('{"monthly_visitor_count_in_millions":425,"paper_count_in_millions":64,"scanned_paper_count_in_millions":300}')